import { useQuery } from '@apollo/react-hooks';
import { type ApolloError } from '@apollo/react-hooks';
import { GET_STUDENT_FILES } from './CHECK_LIST.gql';
import { type FileData } from '../../../../../components';

type StudentFiles = {
  transcript: FileData[];
  certificate: FileData[];
};

type GetStudentFiles = {
  studentFiles: StudentFiles;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetStudentFiles = (id: string): GetStudentFiles => {
  const { data, loading, error } = useQuery(GET_STUDENT_FILES, {
    variables: { id },
    skip: !id,
  });

  const firstDegreefiles = data?.application?.academicQualifications?.[0] ?? {};

  const studentFiles = {
    transcript: firstDegreefiles?.transcript ?? [],
    certificate: firstDegreefiles?.certificates ?? [],
  };

  return {
    studentFiles,
    loading,
    error,
  };
};
